enum ArchiveStatus {
    Archived = 1,
    Expired,
    Purged,
    NotArchived,
}

export default ArchiveStatus;
